"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hexToRgba = exports.decimalToHexadecimal = exports.remToPx = exports.pxToRem = void 0;
const PIXELS_IN_ONE_REM = 16;
function pxToRem(value, rate = PIXELS_IN_ONE_REM) {
    return value / rate;
}
exports.pxToRem = pxToRem;
function remToPx(value, rate = PIXELS_IN_ONE_REM) {
    return value * rate;
}
exports.remToPx = remToPx;
const HEXADECIMAL_BASE = 16;
function decimalToHexadecimal(value) {
    return parseInt(value, HEXADECIMAL_BASE);
}
exports.decimalToHexadecimal = decimalToHexadecimal;
function hexToRgba(hexColor, opacity = 1) {
    const twoLettersRegex = /\w\w/g;
    const [r, g, b] = hexColor.match(twoLettersRegex).map(decimalToHexadecimal);
    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
}
exports.hexToRgba = hexToRgba;
